import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import moment from "moment";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { makeStyles } from "@mui/styles";

import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import { exportExcel } from "../../utils/excel";
import ExcelIcon from "../../icons/ExcelIcon";
import { spinnerAtom } from "../../states/Atoms/StatusAtoms";

const useStyles = makeStyles({
  withDate: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "20px",
    width: "calc(100% - 40px)",
    maxWidth: "650px",
    border: "2px solid #efefef",
    borderRadius: "5px",
    boxShadow:
      "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  },
  noDate: (props) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "calc(100% - 40px)",
    maxWidth: "650px",
    padding: "20px",
    border: "2px solid #efefef",
    borderRadius: "5px",
    boxShadow:
      "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  }),
  title: {
    fontSize: "20px",
    margin: "0 0 10px 0",
  },
  tcmsNewTitle: {
    fontSize: "20px",
    margin: "0",
  },
});

const ExcelDownloadCard = ({ title, url, filename }) => {
  const isNewList = title.includes("New");
  const isFtaItemList = title === "TCMS FTA 적용 현황 품목 다운로드";

  const [startDate, setStartDate] = useState(
    moment()
      .subtract(isNewList ? "3" : "1", "M")
      .format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const setIsLoading = useSetRecoilState(spinnerAtom);

  const classes = useStyles();

  const onChangeStartDate = (e) => {
    setStartDate(e.target.value);
  };

  const onChangeEndDate = (e) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    if (startMoment.isAfter(endMoment)) {
      setEndDate(startDate);
      return;
    }

    if (isNewList) {
      const diffMonths = endMoment.diff(startMoment, "months", true);
      if (diffMonths > 3) {
        setEndDate(startMoment.clone().add(3, "months").format("YYYY-MM-DD"));
      }
    }
  }, [startDate]);

  useEffect(() => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    if (endMoment.isBefore(startMoment)) {
      setStartDate(endDate);
      return;
    }

    if (isNewList) {
      const diffMonths = endMoment.diff(startMoment, "months", true);
      if (diffMonths > 3) {
        setStartDate(
          endMoment.clone().subtract(3, "months").format("YYYY-MM-DD")
        );
      }
    }
  }, [endDate]);

  const onClickDownloadButton = async () => {
    if (moment(endDate).isBefore(startDate)) {
      alert("올바른 기간을 선택해주세요.");
      return;
    }
    try {
      setIsLoading(true);
      const params = { startDate, endDate };

      const res = isFtaItemList
        ? await IVISAxios.post(
            url,
            {
              startDate,
              endDate,
              itemCodeList: test.split(",").map((item) => item.trim()),
            },
            {
              responseType: "arraybuffer",
            }
          )
        : await IVISAxios.get(`${url}`, {
            params,
            headers: {
              "Content-type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8",
            },
            responseType: "arraybuffer",
          });

      console.log("res ", res.data);

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      //   link.download = `${params.startDate}-${params.endDate}_${filename}.xlsx`;
      const downloadFilename = `${params.startDate}-${params.endDate}_${filename}.xlsx`;

      link.download = downloadFilename;
      link.click();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  const [test, setTest] = useState("");

  return (
    <Box component="section" className={classes.withDate}>
      <Typography
        variant="h2"
        sx={{ fontSize: "20px" }}
        className={classes.title}
      >
        {title}
        {!isFtaItemList &&
          (!isNewList ? (
            <Typography
              sx={{
                fontSize: "15px",
                margin: "10px 0 0 0",
                color: "red",
              }}
            >
              {" "}
              * 날짜 기준은 수리 일자 기준으로 계산 됩니다
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: "15px",
                margin: "10px 0 0 0",
                color: "red",
              }}
            >
              * 조회 기간은 최대 3개월을 넘길 수 없습니다
            </Typography>
          ))}
      </Typography>
      {isFtaItemList && (
        <Box>
          <textarea
            style={{
              width: "100%",
              height: "100px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              boxSizing: "border-box",
            }}
            placeholder="품목 코드를 입력하세요 (쉼표로 구분)"
            onChange={(e) => setTest(e.target.value)}
          />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "10px",
            width: "100%",
          }}
        >
          <TextField
            id="startdate"
            label="Start"
            type="date"
            value={startDate}
            sx={{ width: 220 }}
            onChange={onChangeStartDate}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <span>-</span>

          <TextField
            id="enddate"
            label="End"
            type="date"
            sx={{ width: 220 }}
            value={endDate}
            onChange={onChangeEndDate}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>

        <Button
          type="button"
          variant="outlined"
          onClick={onClickDownloadButton}
          aria-label="엑셀 다운로드 버튼"
          title="엑셀 다운로드 버튼"
          sx={{
            minWidth: "80px",
            minHeight: "56px",
            border: "1px solid rgb(22 163 74 / 1)",
            backgroundColor: "rgb(22 163 74 / 1)",

            "&:hover": {
              backgroundColor: "#00ae00",
              borderColor: "#00ae00",
            },
          }}
        >
          <ExcelIcon style={{ width: "24px", height: "24px" }} />
          <FileDownloadIcon
            sx={{ width: "24px", height: "24px", color: "#ffffff" }}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default ExcelDownloadCard;
